export function createRoutes() {
  return [
    {
      path: '',
      component: () => import(/* webpackChunkName: "homepageChrome" */ '@/views/Homepage/HomepageChrome.vue'),
      children: [
        {
          path: '/',
          component: () => import(/* webpackChunkName: "homepageBody" */ '@/views/Homepage/HomepageBody.vue'),
        },
      ],
    },
  ];
}

export default createRoutes;
